export default function trackOmniture(sEvent, sValue) {
    if (!window.fastco_s) {
        // console.error('Omniture not initialized, please include omniture s_code.js');
        return;
    }

    if (!sEvent || !sValue) {
        // console.error('Tracking parameters not provided');
        return;
    }

    //sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
}
